import { render, staticRenderFns } from "./TopicT.vue?vue&type=template&id=ecc4d4da"
import script from "./TopicT.vue?vue&type=script&lang=js"
export * from "./TopicT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports